// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"c55fc80e","488":"91d4ad9a"}[chunkId] + ".chunk.js";
};